import { IMenu } from 'interfaces';
import { AnyAction } from 'redux';
import { Types } from '../actions/types';
import { MENU_ITEMS } from '../../utils';
import sortItems from '../../utils/sortItems'

const sortedMenuItems = sortItems(MENU_ITEMS, 'title')
const initialState: IMenu.StateToProps = {
  isOpen: true,
  menuItems: sortedMenuItems as IMenu.IMenuItem[],
};

export function menu(
  state: IMenu.StateToProps = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case Types.SIDE_MENU_OPEN:
      return {
        ...state,
        isOpen: true,
      };
    case Types.SIDE_MENU_COLLAPSE:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}
